/* v8 ignore start */

import loadable from '@loadable/component'

export const BankClosureTool = loadable(
  () => import('@which/static-tools/build/tools/BankClosureTool'),
  {
    ssr: false,
  }
)

export const NationalInsuranceCalculator = loadable(
  () => import('@which/static-tools/build/tools/NationalInsuranceCalculator'),
  {
    ssr: false,
  }
)

export const IncomeTaxCalculator = loadable(
  () => import('@which/static-tools/build/tools/IncomeTaxCalculator'),
  {
    ssr: false,
  }
)

export const PensionCalculator = loadable(
  () => import('@which/static-tools/build/tools/PensionCalculator'),
  {
    ssr: false,
  }
)

export const ChildBenefitCalculator = loadable(
  () => import('@which/static-tools/build/tools/ChildBenefitCalculator'),
  {
    ssr: false,
  }
)

export const MarriageAllowanceTool = loadable(
  () => import('@which/static-tools/build/tools/MarriageAllowanceTool'),
  {
    ssr: false,
  }
)

export const PensionWithdrawalCalculator = loadable(
  () => import('@which/static-tools/build/tools/PensionWithdrawalCalculator'),
  {
    ssr: false,
  }
)

export const CarModelReliabilityTool = loadable(
  () => import('@which/static-tools/build/tools/CarModelReliabilityTool'),
  {
    ssr: false,
  }
)

/* v8 ignore stop */
